import $ from 'jquery';
import lazySizes from 'lazysizes';

class AnchorNav {
  constructor() {
    this.anchorNav = $('.js-anchor-nav');

    if (!this.anchorNav.length) {
      return;
    }

    this.pageContent = $('.js-page-content');
    this.anchorNavHelper = $('.js-anchor-nav-helper');
    this.anchorNavPositionElement = $('.js-anchor-nav-position');
    this.anchorNavLink = this.anchorNav.find('.js-anchor-nav-link');

    this.anchorNavMinOffsetTop = 0;

    this.preloadContentImages();

    $(window).on('load', () => {
      this.anchorNavMinTopPosition();
      this.anchorNavtarget();
      this.anchorNavSticky();
    });

    $(window).on('scroll', () => {
      this.anchorNavSticky();
    });
  }

  preloadContentImages() {
    const lazyImages = this.pageContent.find('.lazyload');

    if (lazyImages.length) {
      $.each(lazyImages, (i, el) => {
        lazySizes.loader.unveil(el);
      });
    }
  }

  anchorNavSticky() {
    if (this.anchorNav.hasClass('is-sticky')) {
      const anchorNavHeight = this.anchorNav.outerHeight();

      const maxTopOffset =
        this.anchorNav.parent().outerHeight() - anchorNavHeight - 50;

      const startPosition =
        this.anchorNav.parent().offset().top + this.anchorNavMinOffsetTop + 30;
      const scrollTopPos = $(window).scrollTop();
      const positionTop = scrollTopPos - startPosition;

      if (scrollTopPos > startPosition) {
        let topPos = positionTop + this.anchorNavMinOffsetTop + 10;

        if (positionTop + anchorNavHeight >= maxTopOffset) {
          topPos = maxTopOffset;
        }

        this.anchorNav.css({
          top: topPos,
        });
      } else {
        this.anchorNav.css({
          top: this.anchorNavMinOffsetTop,
        });
      }
    } else {
      this.anchorNav.css({
        top: this.anchorNavMinOffsetTop,
      });
    }
  }

  anchorNavMinTopPosition() {
    this.anchorNav.stop().animate({ opacity: 1 }, 300);

    if (this.anchorNavPositionElement.length && this.anchorNavHelper.length) {
      this.anchorPositionOffsetTop = this.anchorNavPositionElement.offset().top;
      this.anchorNavHelperOffsetTop = this.anchorNavHelper.offset().top;
      this.anchorNavMinOffsetTop =
        this.anchorPositionOffsetTop - this.anchorNavHelperOffsetTop - 30;
    }
  }

  anchorNavtarget() {
    this.anchorNavLink.on('click', e => {
      e.preventDefault();

      const self = $(e.currentTarget);
      const targetId = self.attr('href');
      const target = this.pageContent.find(targetId);

      if (target.length) {
        $('body, html')
          .stop()
          .animate({
            scrollTop: target.offset().top - 20,
          });
      }
    });
  }
}

export default new AnchorNav();



// WEBPACK FOOTER //
// ./src/scripts/modules/anchor-nav.js